'use client'

import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from './Input';

export default function KeywordForm({ keyword, isOptOut, languageOptions, countryOptions, onSubmit }) {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: keyword || {
      language: '',
      countryCode: '',
      words: '',
      reply: '',
      optOut: isOptOut,
      defaultKeyword: false
    }
  });

  return (
    <form id="keyword-form" onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <input type="hidden" {...register('optOut')} />

      {keyword?.temp_id &&
        <input type="hidden" {...register('temp_id')} />
      }
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          as="select"
          label="Language"
          required
          options={languageOptions}
          {...register('language')}
          error={errors.language?.message}
        />
        
        <Input
          as="select"
          label="Country"
          required
          options={countryOptions}
          {...register('countryCode')}
          error={errors.countryCode?.message}
        />
      </div>

      <Input
        label="Keywords (comma separated)"
        placeholder="e.g. stop, cancel, unsubscribe"
        required
        {...register('words')}
        error={errors.words?.message}
      />

      <Input
        as="textarea"
        label="Reply message"
        required
        rows={3}
        {...register('reply')}
        error={errors.reply?.message}
      />

      <Input
        label="Default keyword"
        as="checkbox"
        {...register('defaultKeyword')}
      />
    </form>
  );
}